export default __webpack_public_path__ + "static/media/38_the_glue.a20ffd3d.png";